import axios from "axios";

const instance = axios.create({
baseURL: "https://ingenioback.idslatam.com/Idea",
  // baseURL: "https://ingeniobackqas.idslatam.com/Idea",
  //DEMO - Pan America
  // baseURL: "https://ingeniodemoback.idslatam.com/Idea",
 // baseURL: "https://localhost:5001/",
  //baseURL: "https://ingenioqas-poderosa.idslatam.com/Idea",
});

var token = window.localStorage.getItem("jwt");

instance.defaults.headers.common["Authorization"] = `Bearer ${token}`;

export default instance;
